import React, { useState, useEffect } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import AppstoreIcon from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import GoogleplayIcon from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import { useIntl, useHistory, getLocale } from 'umi';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import BubbleClose from '@/pages/intelligence/components/BubbleClose';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { getGenreColumns } from '@/pages/intelligence/v3/utils/topcharts';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import Databarin from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import DatabrainBubbleTip from '@/pages/intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import {
  valueFormat,
  growthFormat,
} from '@/pages/intelligence/utils/commonUtils';
import { useDispatch } from 'umi';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { DemographicsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DemographicsCloums';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import CustomTable from '@/pages/intelligence/components/TableComponents/CustomTable';
import { Table, PagingQuery } from 'tea-component';
import InsideTable from './InsideTable';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { changeSingleTimeToRange } from '@intelligence/utils/filterUtils';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';
import { formatReleaseTime } from "@home/components/NavHeader/sreachContext/utils";
import { getTagFilterColumns } from '@intelligence/v3/utils/sensorTowerTagColumns';

const { expandable, pageable, scrollable, autotip } = Table.addons;

const platformIcons = {
  ios: AppstoreIcon,
  android: GoogleplayIcon,
} as any;

const Demographics = (props: any) => {
  const {
    showFirstGuide,
    loading,
    records = [],
    tableTotal = 0,
    pageSortAttr,
    tableSelection,
    tableSelectionAll,
    onTableSortChage,
    onTablePagingChange,
    onTableCheckGame,
    selectDataSources,
    dateType,
    genreSource = 'sensortower',
    fetchParams,
    ageSortList,
    entityType,
    onAppMagicTagClick,
    source = 'appannie',
    filterValue,
    gameDetailsLoading = true,
    gameDetailsMapping = {},
    onTagClick,
    pageId,
  } = props;
  const UNIFIED_ID = 'unified_id';
  const APP_ID = 'app_id';

  const { filterExtend, setFilterExtend, resetFilterExtend, isOperate } = useFilterExtend({
    pageId,
  });
  const pageSizeOptions = [20, 50, 100];
  const [expandedKeys, setExpandedKeys] = useState<any>([]);

  const loadingOrNodata = loading || !records?.length;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();

  const {
    tablePageIndex,
    tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    currentOrderSource,
  } = pageSortAttr || {};
  const history = useHistory();
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  const [bubbleVisible, setBubbleVisible] = useState(false);
  const [columns, setColumns] = useState([]);
  //展开国家下探需要的参数
  const [selectUnid, setSelectUnid] = useState('');
  const [showShadow, setShowShadow] = useState(false);
  let hideDemographicsTableTip =
    localStorage.getItem('showDemographicsTableTip') === 'false'; //默认是null, 默认弹窗
  const [showIconBubble, setShowIconBubble] = useState(
    !hideDemographicsTableTip,
  );
  const openClick = (keys, event, operateRecord) => {
    setSelectUnid(operateRecord?.[UNIFIED_ID] || operateRecord?.[APP_ID] || '');
    setExpandedKeys(keys);
  };

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const detailCloums = DetailsCloums({
    onClickGame: (cvm: any) => {
      onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID]);
    },
    formatMessage,
  });

  const mauMetric = [
    {
      // text: 'MAU',
      text: formatMessage({ id: `dbi_metric_mau` }),
      value: 'mau',
      renderType: RenderType.VALUE_AND_RATIO,
      dataSource: source,
      width: 180,
    },
    {
      text: formatMessage({ id: `dbi_top_gender_breakdown` }),
      value: 'gender',
      renderType: RenderType.TABLE_BAR_CHART,
      dataSource: source,
      width: 280,
    },
    {
      text: formatMessage({ id: `dbi_top_age_breakdown` }),
      value: 'age',
      renderType: RenderType.TABLE_BAR_CHART,
      dataSource: source,
      width: 400,
    },
  ];

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    if (!cvm || !metricKey) {
      return undefined;
    }
    const metrics = cvm?.metric_list || [];
    const metric = Array.isArray(metrics) && metrics?.find((item: any) => item.metric === metricKey);

    const value = valueFormat(metric?.value, false, 0);
    const growthDataObj = growthFormat({
      value: metric?.dod,
      valueType: 'pointValue',
      hasPoint: 'lessThanOne',
      fixedNum: 2,
      maxNumber: 99999,
    });
    return { value, growthDataObj };
  };
  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    mauMetric.forEach((t) => {
      metricCloums.push(
        DemographicsCloums({
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: undefined,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: ['gender', 'age']?.includes(t?.value)
            ? currentSortMetric
            : `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          getMetricValueOfCvm: getMetricValueOfCvm,
          formatMessage,
          ageSortList: ageSortList,
          entityType,
          sortByDropdownBoxClassName: 'dbi-top-charts-demographics-sort-by',
        }),
      );
    });
    return metricCloums;
  };

  useEffect(() => {
    const cloumss = [
      {
        key: 'select',
        width: 36,
        fixed: 'left',
        header: () => {
          return (
            <TableCheckboxHeader
              selectList={selectList}
              tableSelectionAll={tableSelectionAll}
              // disabled={loading || records.length === 0}
              onChange={(list, stats) => {
                onTableCheckGame(list, stats);
                setSelectList(list);
              }}
            />
          );
        },
        render: (cvm: any) => {
          return (
            <TableCheckboxRender
              selectList={selectList}
              cvm={{ ...(cvm || {}), gameId: cvm?.[APP_ID] }}
              disabled={getGameRankDetails(cvm?.rank).isDisabled}
              onChange={(list, status) => {
                setSelectList(list);
                onTableCheckGame(list, status);
              }}
            />
          );
        },
      },
      {
        key: 'gametitle',
        header: (
          <div className="dbi-firstRow-flex">
            <div className="dbi-text-id">#</div>
            <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
          </div>
        ),
        width: 330,
        fixed: 'left',
        render: (cvm: any) => {
          const platform = Array.isArray(cvm?.platform)
            ? cvm.platform[0]
            : cvm?.platform;
          const platformIcon = platformIcons[platform];
          return (
            <FirstRow
              id={cvm?.insideTable ? <></> : getGameRankDetails(cvm?.rank)?.rankText}
              cvm={{
                img: cvm?.cover,
                gametitle: cvm?.name,
                countryIcon: getCountryFlag(cvm?.publisher_addr),
                text: cvm?.publisher,
                isDatabrain: cvm.b_ogdb_data ? Databarin : '',
                databrainIconTip: <DatabrainBubbleTip />,
                frontIcon: platformIcon,
              }}
              rihgtClickToJumpHref={getDetailGamePath(cvm?.[UNIFIED_ID])}
              onClick={() => {
                onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID]);
              }}
            />
          );
        },
      },
      ...getMetricCloums(),
      {
        key: 'release_time',
        header: (
          <CloumsCenter width={140} align="left">
            <div className="header-other">
              {formatMessage({ id: 'dbi_release_date' })}
            </div>
          </CloumsCenter>
        ),
        align: 'center',
        width: 140,
        render: (cvm: any) => {
          const releaseTime = formatReleaseTime(locale, {
            isSpecialReleaseTime: cvm?.is_special_release_time,
            releaseTime: cvm?.release_time,
            releaseTimeEN: cvm?.release_time_en,
            releaseTimeCN: cvm?.release_time_cn,
          });
          return (
            <CloumsCenter width={140} align="left">
              {releaseTime}
            </CloumsCenter>
          );
        },
      },
      ...getGenreColumns({
        isGameDetailsMode: false,
        genreSource: genreSource as any,
        formatMessage,
        onAppMagicTagClick,
      }),
      ...getTagFilterColumns({
        filterValue,
        gameDetailsLoading,
        gameDetailsMapping,
        locale,
        formatMessage,
        onTagClick,
      }),
      detailCloums,
    ];
    setColumns(cloumss);
  }, [records, selectList, locale, genreSource, filterValue, gameDetailsLoading, gameDetailsMapping, onTagClick]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setBubbleVisible(showFirstGuide && !loading && records.length > 0);
  }, [showFirstGuide, loading, records.length]);

  const onBubbleClose = () => {
    //表格关注提示关闭打点
    buriedBtnPoint(dbiBtnLogMes.topchartMobileGameActiveUserTableTip);
    setBubbleVisible(false);
  };

  const getDetailGamePath = (gameId: string) => {
    return getDetailGamePathCommon({
      entityType: 'mobile',
      gameId: gameId,
      tab: 'demographics',
      subTab: '',
    });
  };

  const onClickGame = (unifiedId: string, appId: string) => {
    //如果操作了筛选器 , Demographics跳转到详情时间需要往前推几个月
    if (isOperate) {
      const updateTimeFilter = changeSingleTimeToRange({
        timeType: 'month',
        subtractNum: 5,
        filterExtend: filterExtend,
      });
      setFilterExtend(updateTimeFilter);
    }
    dispatch({ type: `${DBI_TOPCHARTS}/setDemographicsAppid`, payload: appId });
    history.push(getDetailGamePath(unifiedId));
  };

  /**展示表格下拉提示*/
  /**测试：
   * 1 第一页展示， 在首屏展示的， 比如rank1行
   * 2 第一页： 首屏展示没有， 需要滚动表格展示的 ，如果rank13行
   * 3 翻页： 是否直接展示，还是需要滚动列表才展示
   * 4 搜索， 清除搜索， 清除搜索后滚动列表是否在页面外
   * 5 以上各种情况可滚动表格外的页面滚动再查看 -- 用这个属性解决：escapeWithReference
   */
  const aNode = document.querySelector(
    '#demographics-topcharts-table .tea-table .tea-table__body',
  );
  const bNode = document.getElementById('demographics-table-tips-overlay');
  const bubbleIconShow = () => {
    if (aNode && bNode) {
      const showOrHideBubble = (hidden: boolean) => {
        if (hidden) {
          bNode.style.visibility = 'hidden';
        } else {
          bNode.style.visibility = 'visible';
        }
      };
      //初始化，Bubble在底下
      const hidden =
        bNode.getBoundingClientRect().top + bNode.clientHeight + 5 >=
          (document.querySelector('body')?.clientHeight || 0) ||
        aNode.getBoundingClientRect().top >
          bNode.getBoundingClientRect().top + bNode.clientHeight + 5;
      showOrHideBubble(hidden);
    }
  };
  useEffect(() => {
    bubbleIconShow();
  }, [JSON.stringify(fetchParams)]);

  if (aNode && bNode) {
    aNode.addEventListener('scroll', () => {
      bubbleIconShow();
    });
  }

  return (
    <CardSlotV2>
      {/* sub-table-same 公共类名 */}
      <div id="demographics-topcharts-table">
        <CustomTable
          loading={loading}
          records={records}
          className="dbi-mobile-table sub-table-same dbi-mobileGames-table dbi-table-sticky"
          recordKey={APP_ID}
          // bordered="all"
          columns={columns}
          tableTotal={tableTotal}
          pageSize={pageSize}
          pageIndex={pageIndex}
          onPagingChange={(e) => {
            if (onPagingChange instanceof Function) {
              onPagingChange(e);
            }
          }}
          tableAddons={[
            // scrollable({ minHeight: 80 }),
            scrollable({
              minWidth: 'auto',
              // maxHeight: 'calc(100vh - 288px)',
              minHeight: loadingOrNodata ? '158px' : 'auto',
            }),
            // autotip({
            //   emptyText: 'No data under current selections',
            // }),
            expandable({
              expandedKeys,
              gapCell: 0,
              shouldRecordExpandable: (record) => {
                return record?.app_ids?.length > 0;
              },
              iconRender: (element, context) => {
                return context.record.rank === context.record?.firstIconRank ? (
                  <BubbleClose
                    id={'demographics-table-tips-overlay'}
                    style={{ width: '400px' }}
                    placement="top-start"
                    placementOffset={[-20, 15]}
                    content={
                      <p>
                        {formatMessage({
                          id: `dbi_info_demographics_click_particular`,
                        })}
                      </p>
                    }
                    visible={showIconBubble}
                    onClose={() => {
                      setShowIconBubble(false);
                      localStorage.setItem('showDemographicsTableTip', 'false');
                    }}
                  >
                    <>{element}</>
                  </BubbleClose>
                ) : (
                  element
                );
              },
              gapCellRender: (record) => 'gapCellRender',
              onExpandedKeysChange: (keys, { event, operateRecord }) => {
                event.stopPropagation();
                openClick(keys, event, operateRecord);
              },
              render(record) {
                // game_code 需要去掉当前行的 app_id，只保留其余的 app_ids
                const filteredAppIds = (record?.app_ids || []).filter(
                  (id: string) => id !== record?.app_id,
                );
                return (
                  <InsideTable
                    fetchParams={fetchParams}
                    columns={columns}
                    appids={filteredAppIds}
                    unifiedId={record?.[UNIFIED_ID]}
                  />
                );
              },
            }),
          ]}
        />
      </div>
    </CardSlotV2>
  );
};

export default Demographics;
